import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { toReturnRec } from "../lib/return-vm";

export function useReturn(returnId: string) {
  return useQuery({
    queryKey: ["return", returnId],
    enabled: !!returnId,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/returns/{return_id}", {
        params: { path: { return_id: returnId } },
      });
      if (error) throw error;
      return toReturnRec(data);
    },
  });
}
